/****************************************************************************
 * Copyright 2021 EPAM Systems
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 ***************************************************************************/

export const UnresolvedMonomerAvatar = () => (
  <>
    <symbol id="unresolved-monomer" viewBox="0 0 59 59" width="59" height="59">
      <rect
        className="monomer-body"
        width="29.5"
        height="29.5"
        data-actual-width="29.5"
        data-actual-height="29.5"
        x="0.5"
        y="0.5"
        rx="1.5"
        stroke="#333333"
      />
      <rect
        width="29.5"
        height="29.5"
        data-actual-width="29.5"
        data-actual-height="29.5"
        x="0.5"
        y="0.5"
        rx="1.5"
        fill="#585858"
      />
    </symbol>
    <symbol id="unresolved-monomer-hover">
      <rect
        width="29.5"
        height="29.5"
        x="0.5"
        y="0.5"
        rx="1.5"
        fill="none"
        stroke="#0097A8"
        strokeWidth="1.5"
      />
    </symbol>
    <symbol
      id="unresolved-monomer-autochain-preview"
      viewBox="0 0 32 32"
      width="32"
      height="32"
      data-actual-width="32"
      data-actual-height="32"
    >
      <path d="M1 4.63574V2.63574C1 1.53117 1.89543 0.635742 3 0.635742H5" />
      <path d="M1 26.6357V28.6357C1 29.7403 1.89543 30.6357 3 30.6357H5" />
      <path d="M31 4.63574V2.63574C31 1.53117 30.1046 0.635742 29 0.635742H27" />
      <path d="M31 26.6357V28.6357C31 29.7403 30.1046 30.6357 29 30.6357H27" />
      <path d="M7.02142 30.6357L10.0214 30.6357" />
      <path d="M12.0013 30.6357L15.0013 30.6357" />
      <path d="M16.9816 30.6357L19.9816 30.6357" />
      <path d="M22.0222 30.6357L25.0222 30.6357" />
      <path d="M1.02185 6.63574L1.02185 9.63574" />
      <path d="M1.02185 11.6152L1.02185 14.6152" />
      <path d="M1.02185 16.5957L1.02185 19.5957" />
      <path d="M1.02185 21.6367L1.02185 24.6367" />
      <path d="M7.02142 0.635742L10.0214 0.635742" />
      <path d="M12.0013 0.635742L15.0013 0.635742" />
      <path d="M16.9816 0.635742L19.9816 0.635742" />
      <path d="M22.0222 0.635742L25.0222 0.635742" />
      <path d="M31.0219 6.63574L31.0219 9.63574" />
      <path d="M31.0219 11.6152L31.0219 14.6152" />
      <path d="M31.0219 16.5957L31.0219 19.5957" />
      <path d="M31.0219 21.6367L31.0219 24.6367" />
    </symbol>
  </>
);
